export async function fetchData(url, params) {
  return fetch( process.env.REACT_APP_URL_SERVER + url, params )
  .then(response => response.json())
  .then(data => { return data })
  .catch(err => { return { code: 503, message: "Service Unavailable", data: false } })
}